import { Injectable } from '@angular/core';
import {
  AccessPermissionService,
  dblclickTooltipDef,
  defaultColumn,
  grid_widths_map,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { ColDef } from 'ag-grid-community';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductManufactureDataGridService {
  event: any;
  productManufacturePayload: any;

  editPopupOpenManufacture = new Subject<[any]>();
  editPopupOpenManufactureData$ = this.editPopupOpenManufacture.asObservable();

  editProdUse = new Subject<[any]>();
  editProdUseData$ = this.editProdUse.asObservable();

  constructor(private accessService: AccessPermissionService) {}

  getProductManufactureDataColumn(from?: any): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'FillingName',
      headerName: 'Product use process',
      field: 'fillingName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      cellStyle: { 'text-decoration': 'underline' },
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          from == 'product-use'
            ? this.editProdUse.next(params?.data)
            : this.editPopupOpenManufacture.next(params.data?.ingredientId);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Amount',
      headerName: 'Amount',
      field: 'amount',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      sortable: false,
    });

    this.accessService.hasPermission('edit', '') &&
      colDef.push({
        ...defaultColumn,
        colId: 'actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        suppressColumnsToolPanel: true,
        cellRenderer: 'actionRenderer',
        cellRendererParams: {
          showDelete: false,
          showEdit: true,
          editData: (data: any, pathName: any) => {
            from == 'product-use'
              ? this.editProdUse.next(data)
              : this.editPopupOpenManufacture.next(data?.ingredientId);
          },
        },
        lockVisible: true,
        lockPosition: right,
        resizable: false,
      });
    return colDef;
  }

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getProductManufactureDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.productManufacturePayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'FillingName',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Desc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }
}
